export default __webpack_public_path__ + "static/media/Wall_Conveyor_Perpendicular_Grey.64.5c1ebe7f.png";